import styled from "styled-components";

const MODAL_WIDTH = 476;
const MODAL_BORDER_RADIUS = 8;
const PRIMARY_BUTTON_RADIUS = 500;
const SECONDARY_BUTTON_RADIUS = 100;

export const CancelModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  width: ${MODAL_WIDTH}px;
  max-width: calc(100vw - 32px);
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${MODAL_BORDER_RADIUS}px;
  box-shadow: 0 16px 48px 0 rgba(0, 0, 0, 0.24);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
`;

export const CancelModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  align-self: stretch;
`;

export const CancelModalTitle = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 22px;
  line-height: 28px;
  font-weight: 400;
  color: #202224;
`;

export const CancelModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  padding: 0 24px 0 16px;
  gap: 16px;
`;

export const CancelModalMessage = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #202224;
  text-align: center;
`;

export const CancelModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 24px;
  padding: 16px 24px;
`;

export const continueEditingButtonSx = {
  textTransform: "none" as const,
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  borderRadius: `${SECONDARY_BUTTON_RADIUS}px`,
  padding: "10px 12px",
  textDecoration: "underline",
  color: "primary.main",
  "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "underline",
  },
};

export const confirmCancelButtonSx = {
  textTransform: "none" as const,
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  borderRadius: `${PRIMARY_BUTTON_RADIUS}px`,
  padding: "10px 24px",
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none",
  },
};
